import { apiFetch } from '@/api/apiFetch';

async function postPdfExport(widthInMm: number, heightInMm: number, imgRecto?: Blob, imgVerso?: Blob): Promise<Blob> {
    const formData = new FormData();
    formData.append('widthInMm', String(widthInMm));
    formData.append('heightInMm', String(heightInMm));
    if (imgRecto) {
        formData.append('images', imgRecto, 'recto.jpg');
    }
    if (imgVerso) {
        formData.append('images', imgVerso, 'verso.jpg');
    }
    const response = await apiFetch('/pdf/export', { method: 'POST', body: formData });
    return response.blob();
}

export { postPdfExport };
